import React, { useCallback, useRef, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import Table from './components/table/Table'
import { useTranslation } from 'react-i18next'
import Wrapper from 'components/reusables/wrapper'

const MIN_SEARCH_LENGTH = 3

const Hierarchy: React.FC = () => {
  const { t } = useTranslation()
  const bounceId = useRef(0)

  const [searchText, setSearchText] = useState('')

  const handleSearch = useCallback((value: any) => {
    if (bounceId.current) {
      clearTimeout(bounceId.current)
    }
    if (value.length >= MIN_SEARCH_LENGTH || !value.length) {
      bounceId.current = window.setTimeout(() => {
        setSearchText(value.trim())
      }, 1000)
    }
  }, [])

  return (
    <Wrapper shadow={true}>
      <Row>
        <Col>
          <h1>{t('configuration.hierarchy.title')}</h1>
          <p>{t('configuration.hierarchy.subtitle')}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table searchText={searchText} handleSearch={handleSearch} />
        </Col>
      </Row>
    </Wrapper>
  )
}

export default Hierarchy
